'use client'

import Link from 'next/link'
import Typography from 'src/components/design-system/Typography'
import { useState, useRef } from 'react'
import { gsap } from 'gsap'
import Arrow from 'public/icons/arrows/expanded-arrow.svg'
import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'
const ReviewerItem = ({ position, fullname, affiliation, url = null, className = '', desc }) => {
  const Wrapper = url ? Link : 'div'
  const wrapperProps = url ? { href: url } : {}
  const translate = useTranslateEntry()
  const [open, setOpen] = useState(false)
  const contentRef = useRef(null)
  const wrapperRef = useRef(null)

  const toggle = () => {
    setOpen((prev) => !prev)

    if (!contentRef.current || !wrapperRef.current) return

    if (!open) {
      gsap.fromTo(
        wrapperRef.current,
        { height: 0 },
        {
          height: contentRef.current.scrollHeight,
          duration: 0.4,
          ease: 'power2.out',
          onComplete: () => {
            wrapperRef.current.style.height = 'auto'
          },
        },
      )
    } else {
      gsap.fromTo(
        wrapperRef.current,
        { height: wrapperRef.current.scrollHeight },
        {
          height: 0,
          duration: 0.35,
          ease: 'power2.inOut',
        },
      )
    }
  }

  const descId = `desc-${fullname?.replace(/\s+/g, '-').toLowerCase()}`
  return (
    <Wrapper {...wrapperProps} className={`flex flex-col gap-y-48 ${className}`}>
      {/* {title && (
        <Typography variant="h3-light" component="p" color={`text-basic-black`} className={'pt-24'}>
          {title}
        </Typography>
      )} */}
      <Typography variant="h3-bold" component="p" color={`text-basic-black`} className={'pt-24'}>
        {position} {fullname}
      </Typography>
      {affiliation && (
        <Typography variant="h4" component="p" color={`text-basic-black`} className={'pt-24'}>
          {affiliation}
        </Typography>
      )}
      {desc && (
        <div className="w-full">
          <button
            onClick={toggle}
            aria-expanded={open}
            aria-controls={descId}
            className="w-full flex items-center justify-end gap-x-8 border-b border-dark-blue-dark-blue1 py-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-dark-blue-dark-blue1"
          >
            <Typography variant="body3-normal" className="flex items-center gap-x-8">
              {open ? translate('T_LESS') : translate('T_MORE')}
            </Typography>

            <Arrow
              className={`transition-transform duration-300 ${open ? 'rotate-180' : 'rotate-0'}`}
              aria-hidden="true"
            />
          </button>

          <div ref={wrapperRef} id={descId} className="overflow-hidden h-0" aria-live="polite">
            <div ref={contentRef} className="pt-16">
              <Typography variant="body3-normal" color="text-basic-black">
                {desc}
              </Typography>
            </div>
          </div>
        </div>
      )}
    </Wrapper>
  )
}

export { ReviewerItem }
